module.exports = __webpack_public_path__ + "img/help3.308b7f9d.png";